import { getWithRootPathGetter, replacePathParams } from '@/api/utils';

const withRoot = getWithRootPathGetter('/opobff/opo-platform');

export const opobffReleaseNotesApiPaths = {
  list: withRoot('/release-notes'),
  byId: withRoot('/release-notes/:releaseNoteId'),
} as const;

export const getOpobffReleaseNotesApiUrl = {
  list: () => opobffReleaseNotesApiPaths.list,
  byId: (releaseNoteId: string) => replacePathParams(opobffReleaseNotesApiPaths.byId, { releaseNoteId }),
};
